module.exports = __webpack_public_path__ + "static/media/gift-card.ba976bd0.svg";